import { eponaMutation, eponaQuery } from '@/helpers/graphql_modules/epona';
import { googleCalendarApiClientId } from '@/settings/constants';
import { initCalendarMutation } from '@/store/mutations/pegasus-epona.mutations';
import { getUserCalendarQuery } from '@/store/queries/pegasus-epona.queries';

export enum CalendarStatus {
  LINKED = 'LINKED',
  REVOKED = 'REVOKED',
}

export interface UserCalendar {
  id: string;
  userId: string;
  status: CalendarStatus;
  provider: string;
  providerCalendarId: string;
  providerUserId: string;
  createdAt: string;
  updatedAt: string;
  subjects: string[];
}

export class UserCalendarService {
  static async getUserCalendar(): Promise<UserCalendar> {
    const {
      data: {
        getUserCalendar: { data, identifier, message },
      },
    } = await eponaQuery(getUserCalendarQuery);

    if (identifier === 'CouldntObtainUserCalendar') {
      throw new Error(message);
    }

    return data;
  }

  static generateAuthUrl(provider: string, redirectUri: string): string {
    if (provider === 'google') {
      const authUrl = new URL('https://accounts.google.com/o/oauth2/v2/auth');
      authUrl.searchParams.set('access_type', 'offline');
      authUrl.searchParams.set('prompt', 'consent');
      authUrl.searchParams.set('response_type', 'code');
      authUrl.searchParams.set('client_id', googleCalendarApiClientId);
      authUrl.searchParams.set(
        'scope',
        [
          'https://www.googleapis.com/auth/calendar.app.created',
          'https://www.googleapis.com/auth/calendar.calendarlist.readonly',
          'openid',
          'profile',
        ].join(' '),
      );
      authUrl.searchParams.set('redirect_uri', redirectUri);

      return authUrl.toString();
    }

    return '';
  }

  static async initUserCalendar(
    provider: string,
    redirectUri: string,
    authorizationCode: string,
    coursesIds: string[] = [],
    disciplineInstancesIds: string[] = [],
  ): Promise<UserCalendar> {
    const {
      data: {
        initCalendar: { data },
      },
    } = await eponaMutation(initCalendarMutation, {
      provider,
      redirectUri,
      authorizationCode,
      coursesIds,
      disciplineInstancesIds,
    });

    return data;
  }
}
